
import Vue from "vue";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { SaleService } from "@/services";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";

export default Vue.extend({
	data(){
		return {
			layout: null as null | SaleLayout,
			sending: false,
			fileName: ""
		};
	},
	computed: {
		allowedExtensions():string[]{
			return [
				"jpg",
				"json"
			];
		}
	},
	methods: {
		async onFile(file:File){
			this.sending = true;
			try{
				if (file.type == "application/json" || file.type == "text/plain"){
					let text = await file.text();
					let data = JSON.parse(text);
					this.layout = new SaleLayout(data.Layout);
				}else{
					this.layout = await SaleService.getLayoutConfFromImage(file);
				}
				this.fileName = file.name;
			}catch(err){
			}
			this.sending = false;
		},
		removeFile(){
			this.fileName = "",
			this.layout = null;
		},
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("layout", this.layout);
			this.$emit("close");
		}
	},
	components: {
		AppFileUpload
	}
});
